const comparisonData = [
  { feature: "Templates", vigorbuy: "Advanced templates", traditional: "Basic templates" },
  { feature: "Organization", vigorbuy: "Structured system", traditional: "Manual setup" },
  { feature: "Business Usage", vigorbuy: "High", traditional: "Medium" },
  { feature: "Beginner Friendly", vigorbuy: "Yes", traditional: "Depends" },
  { feature: "Automation", vigorbuy: "Available", traditional: "Limited" },
  { feature: "Customization", vigorbuy: "Flexible options", traditional: "Standard only" },
  { feature: "Support", vigorbuy: "Comprehensive guides", traditional: "Community forums" },
];

export default function ComparisonTable() {
  return (
    <section id="comparison" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Vigorbuy Spreadsheet Features Comparison
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            See how Vigorbuy Spreadsheet stacks up against traditional spreadsheet solutions.
          </p>
        </div>

        <div className="overflow-x-auto rounded-lg border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-primary-500 text-background-50">
                <th className="text-left px-5 py-4 font-label font-semibold">Feature</th>
                <th className="text-left px-5 py-4 font-label font-semibold">Vigorbuy Spreadsheet</th>
                <th className="text-left px-5 py-4 font-label font-semibold">Traditional Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={`border-b border-background-200/50 ${
                    idx % 2 === 0 ? "bg-background-50" : "bg-background-100/60"
                  }`}
                >
                  <td className="px-5 py-3.5 font-label font-medium text-foreground-800">
                    {row.feature}
                  </td>
                  <td className="px-5 py-3.5 text-accent-700 font-medium">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-check-fill text-accent-500"></i>
                      {row.vigorbuy}
                    </span>
                  </td>
                  <td className="px-5 py-3.5 text-foreground-600">
                    {row.traditional}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-label font-semibold bg-accent-500 text-background-50 rounded-md hover:bg-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            Try Vigorbuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}